/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlChangeSectionOrder = "/section/change-section-order";

const state = {
  sections: [],
  totalRecords: 0,
  totalPages: 1,
  currentPage: 1,
  communicationTopics: [],
};

const actions = {
  /**
   * Get List sections
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getAllSections({ commit }, { query, isCommit = true }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/chapters?${new URLSearchParams(query)}`)
        .then((response) => {
          if (isCommit) {
            commit("SET_SECTIONS", response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * CreateSection
   * @param commit
   * @param payload
   */
  async createSection({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("chapters", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Update section
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async updateSection({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`chapters/${id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete section
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async deleteSection({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`chapters/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Clone section
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async cloneSection({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`chapters/${id}/duplicate`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete section
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async changeSectionOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/chapters/change-order", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },

  async getFlipBookUrl({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/chapters/${data.id}/flipbook-url`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async transferSection({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/chapters/${id}/transfer`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  SET_SECTIONS(state, data) {
    state.sections = data;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
